(function($, root, undefined) {
  $(function() {
    $('#reset-pw-edit').on('click', function(){
      $('.customer-password').addClass('hide');
      $('#ResetPasswordForm').removeClass('hide');
    });

    $('#hide-reset-pw-form').on('click', function() {
      $('.customer-password').removeClass('hide');
      $('#ResetPasswordForm').addClass('hide');
    });

    $('[data-dz-orders-btn]').on('click', function(){
      ordersShow();
    });

    var location = window.location.href.split('#');
    if(location.length > 1){
      ordersShow();
    }

    function ordersShow(){
      $('[data-dz-profile-container]').addClass('hide');
      $('[data-dz-order-container]').removeClass('hide');

      $('[data-dz-profile-btn]').addClass('dz-no-text-deco');
      $('[data-dz-orders-btn]').removeClass('dz-no-text-deco');
    }

    orderMessage();

    //Orders List Filtering Work
    $('#orderFilter').on('change', function(){
      var fliterVal = $(this).val();
      var curYear = parseInt($('.customer-orders .orders-list').data('cur_year'));
      var curMon = parseInt($('.customer-orders .orders-list').data('cur_mon'));

      switch(fliterVal){
        case '1-year':          
          var filYear = curYear - 1;
          $('.customer-orders .orders-list .single-order').each(function(){
            var orderYear = $(this).data('order_year');
            if(filYear <= orderYear){
              $(this).removeClass('d-none');
              $(this).addClass('d-block');
            } else {
              $(this).removeClass('d-block');
              $(this).addClass('d-none');
            }
          });
          break;
        case '6-mons':
          if(curMon >= 5){
            $('.customer-orders .orders-list .single-order').each(function(){
              var orderYear = $(this).data('order_year');
              if(curYear == orderYear){
                $(this).removeClass('d-none');
                $(this).addClass('d-block');
              } else {
                $(this).removeClass('d-block');
                $(this).addClass('d-none');
              }
            });
          }
          if(curMon == 1){
            $('.customer-orders .orders-list .single-order').each(function(){
              var orderYear = $(this).data('order_year');
              var orderMon = $(this).data('order_mon');
              if(curYear == orderYear){
                $(this).removeClass('d-none');
                $(this).addClass('d-block');
              } else {
                if(orderMon >= 9){
                  $(this).removeClass('d-none');
                  $(this).addClass('d-block');
                } else {
                  $(this).removeClass('d-block');
                  $(this).addClass('d-none');
                }
              }
            });
          }
          if(curMon == 2){
            $('.customer-orders .orders-list .single-order').each(function(){
              var orderYear = $(this).data('order_year');
              var orderMon = $(this).data('order_mon');
              if(curYear == orderYear){
                $(this).removeClass('d-none');
                $(this).addClass('d-block');
              } else {
                if(orderMon >= 10){
                  $(this).removeClass('d-none');
                  $(this).addClass('d-block');
                } else {
                  $(this).removeClass('d-block');
                  $(this).addClass('d-none');
                }
              }
            });
          }
          if(curMon == 3){
            $('.customer-orders .orders-list .single-order').each(function(){
              var orderYear = $(this).data('order_year');
              var orderMon = $(this).data('order_mon');
              if(curYear == orderYear){
                $(this).removeClass('d-none');
                $(this).addClass('d-block');
              } else {
                if(orderMon >= 11){
                  $(this).removeClass('d-none');
                  $(this).addClass('d-block');
                } else {
                  $(this).removeClass('d-block');
                  $(this).addClass('d-none');
                }
              }
            });
          }
          if(curMon == 4){
            $('.customer-orders .orders-list .single-order').each(function(){
              var orderYear = $(this).data('order_year');
              var orderMon = $(this).data('order_mon');
              if(curYear == orderYear){
                $(this).removeClass('d-none');
                $(this).addClass('d-block');
              } else {
                if(orderMon >= 12){
                  $(this).removeClass('d-none');
                  $(this).addClass('d-block');
                } else {
                  $(this).removeClass('d-block');
                  $(this).addClass('d-none');
                }
              }
            });
          }
          break;        
        default:
          //2-years
          var twoYear = curYear - 2;
          $('.customer-orders .orders-list .single-order').each(function(){
            var orderYear = $(this).data('order_year');
            if(twoYear <= orderYear){
              $(this).removeClass('d-none');
              $(this).addClass('d-block');
            } else {
              $(this).removeClass('d-block');
              $(this).addClass('d-none');
            }
          });
      }

      orderMessage();
    });

    function orderMessage(){
      var orders_num = parseInt($('.customer-orders .orders-list').data('order_size'));
      var activeOrders = parseInt($('.customer-orders .orders-list .single-order.d-none').length);

      if(orders_num == activeOrders){
        $('.order-empty-message').removeClass('d-none');
      } else {
        $('.order-empty-message').addClass('d-none');
      }
    }

    //Add New Addresse
    $('#AddressNewButton').on('click', function(){
      $(this).addClass('hide');
      $('.new-addr-form').removeClass('hide');
    });
  });
  
})(jQuery, this);